import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledLeadScoreTooltipFooter = styled(Flex)`
    padding: 20px 20px 24px 20px;
    border-top: 1px solid ${colorsPalettes.bluegrey[300]};
`;
